<template>
  <v-card class="transfer-fee">
    <div style="padding: 24px">
      <div style="background: #fff !important;">
        <!--        <h2 class="text-center">CHUYỂN PHÍ</h2>-->
        <div class="d-flex justify-space-between">
          <div class="mb-2" style="border-bottom: 3px solid #6F44FF; width: max-content;font-size: 18px;font-weight: bold;color: #6F44FF">Chuyển gói gia sư</div>
          <v-icon style="cursor: pointer" @click="handleClosePopup">
            mdi-close
          </v-icon>
        </div>
        <v-row style="background: #fff">
          <!-- table left-->
          <v-col cols="6" class="border-right">
            <h2 class="text-center ">GÓI HIỆN TẠI</h2>
            <!-- Gói hiện tại -->
            <div class="timeline">
              <!-- THÔNG TIN GÓI CŨ -->
              <div class="timeline-item">
                <div class="timeline-dot">
                  <v-icon color="#6F44FF">mdi-book-open-variant</v-icon>
                </div>
                <div class="timeline-content">
                  <div class="timeline-header">
                    <span class=" mt-1 font-weight-medium" style="color: #6F44FF;font-size: 15px">THÔNG TIN GÓI CŨ</span>
                  </div>

                  <div class="pl-2 mt-2 ">
                    <div  v-if='packageInfo.oldPackageInfo.packageName' class="mb-1">Gói: {{ checkEmptyData(packageInfo.oldPackageInfo.packageName)  }}</div>

                    <v-simple-table class="custom-table mb-2">
                      <template v-slot:default>
                        <thead style="background: #D4D5FF80;color: #5D62D1 !important;">
                        <tr>
                          <th style="width: 162px !important;"></th>
                          <th class="text-center">Tổng số buổi</th>
                          <th class="text-center">Buổi học chính</th>
                          <th class="text-center">Buổi nhận phí</th>
                          <th class="text-center">Buổi Khuyến mãi</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td>Thời hạn học viên có</td>
                          <td class="text-center">
                            {{  checkEmptyData(packageInfo.oldPackageInfo.numberLesson.totalLessons) }}
                          </td>
                          <td class="text-center font-weight-medium" style="color: #6F44FF !important;">
                            {{  checkEmptyData(packageInfo.oldPackageInfo.numberLesson.mainLessons) }}
                          </td>
                          <td class="text-center font-weight-medium" style="color: #6F44FF !important;">
                            {{  checkEmptyData(packageInfo.oldPackageInfo.numberLesson.transferLessons) }}
                          </td>
                          <td class="text-center">
                            {{  checkEmptyData(packageInfo.oldPackageInfo.numberLesson.promotionLessons) }}
                          </td>
                        </tr>
                        <tr>
                          <td>Thời hạn đã học</td>
                          <td class="text-center">
                            {{  checkEmptyData(packageInfo.oldPackageInfo.numberLessonFeeReceived.totalLessons) }}
                          </td>
                          <td class="text-center">
                            {{  checkEmptyData(packageInfo.oldPackageInfo.numberLessonFeeReceived.mainLessons) }}
                          </td>
                          <td class="text-center">
                            {{  checkEmptyData(packageInfo.oldPackageInfo.numberLessonFeeReceived.transferLessons) }}
                          </td>
                          <td class="text-center">
                            {{  checkEmptyData(packageInfo.oldPackageInfo.numberLessonFeeReceived.promotionLessons) }}
                          </td>
                        </tr>
                        <tr>
                          <td colspan="5">
                            <div>
                              Thời hạn được phép chuyển phí:
                              <span class="font-weight-medium"  style="color: #6F44FF !important;">
                              {{  checkEmptyData(packageInfo.oldPackageInfo.numberLessonTransfer) }} buổi
                            </span>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <div class="d-flex align-center" style="column-gap: 5px;">
                      <v-icon size="22" color="#FF4E4E">mdi-bookmark-outline</v-icon>
                      <div style="font-style: italic">
                        Học viên chỉ đươc phép chuyển phí các các buổi
                        <span class="font-weight-medium" style="color: #FF1414">“Buổi học chính”</span> và
                        <span style="color: #FF1414" class="font-weight-medium">“Buổi nhận phí”</span>
                        chưa học và thuộc <span style="color: #FF1414" class="font-weight-medium">đơn hàng đã hoàn thành</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- GIÁ TRỊ DÙNG ĐỂ QUY ĐỔI -->
              <div class="timeline-item">
                <div class="timeline-dot-2">
                  <span class="font-weight-medium" style="color: #6F44FF;font-size: 15px">GIÁ TRỊ DÙNG ĐỂ QUY ĐỔI</span>
                </div>
                <div class="timeline-content">
                  <div class="pl-2 pt-8">
                    <!--                    <div class="mb-2">Căn cứ để quy đổi : Đơn hàng <span style="cursor: pointer;text-decoration:underline ">DH09123</span> (V2)</div>-->
                    <div class="mb-1">Căn cứ để quy đổi : {{ checkEmptyData(packageInfo.basePackageInfo.sourceCode)  }}</div>
                    <div
                        v-if="packageInfo.basePackageInfo.skuTutor && packageInfo.basePackageInfo.skuTutor.name"
                        style="
                              grid-template-columns: repeat(16, minmax(0, 1fr));
                              display: grid;
                              gap: 13px;
                              margin-bottom: 8px;
                              border-radius: 4px;
                              border-left:12px solid #D4D5FF !important;
                              border-right: 1px solid #EDEDED;
                              border-bottom: 1px solid #EDEDED;
                              border-top: 1px solid #EDEDED;
                              padding: 12px 12px 12px 16px">
                      <div style="grid-column: span 7 / span 7;" >
                        <div class="font-weight-medium">SẢN PHẨM QUY ĐỔI</div>
                        <div class="mt-2">{{ packageInfo.basePackageInfo.skuTutor ? checkEmptyData(packageInfo.basePackageInfo.skuTutor.name) : ''  }}</div>
                      </div>
                      <div style="grid-column: span 3 / span 3;">

                        <div class="font-weight-medium"
                             :class="packageInfo.basePackageInfo.skuCombo && packageInfo.basePackageInfo.skuCombo.name ? 'pl-6': 'text-left'"
                        >ĐƠN GIÁ</div>
                        <div class="mt-2">
                          <template v-if="packageInfo.basePackageInfo.skuCombo && packageInfo.basePackageInfo.skuCombo.name">
                            <v-tooltip bottom color="#FFF" max-width="350px" content-class="content-tooltip-transfer">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-on="on"
                                    v-bind="attrs"
                                    color="info"
                                    style="font-size: 20px;cursor: pointer">
                                  mdi-information
                                </v-icon>
                              </template>
                              <div style="color: #000 !important;">
                                <div style="font-weight: 500"> <v-icon size="22" color="#5C5C5C">mdi-bookmark-outline</v-icon> Note</div>
                                <div class="mt-2" >
                                  {{  packageInfo.basePackageInfo.skuTutor ? checkEmptyData(packageInfo.basePackageInfo.skuTutor.name) : '' }} đến từ
                                  <span style="font-style: italic">  {{  packageInfo.basePackageInfo.skuCombo ? checkEmptyData(packageInfo.basePackageInfo.skuCombo.name) : '' }}</span>
                                </div>
                              </div>
                            </v-tooltip>
                          </template>
                          {{ packageInfo.basePackageInfo && packageInfo.basePackageInfo.unitPricePerLesson
                            ? formatPrice(checkEmptyData(packageInfo.basePackageInfo.intoMoney))
                            : 0
                          }}</div>
                      </div>
                      <div style="grid-column: span 3 / span 3;">
                        <div class="font-weight-medium">THỜI HẠN</div>
                        <div class="mt-2 d-flex" style="column-gap: 5px">
                          <div>{{ checkEmptyData(packageInfo.basePackageInfo.numberLesson)  }}</div>
                          <div>buổi</div>
                        </div>
                      </div>
                      <div style="grid-column: span 3 / span 3;">
                        <div class="font-weight-medium">GIÁ MỘT BUỔI</div>
                        <div v-if="packageInfo.basePackageInfo && packageInfo.basePackageInfo.unitPricePerLesson"
                             class="mt-2 d-flex font-weight-medium" style="column-gap: 5px;color:#6F44FF">
                          <div>{{  formatPrice(Round2(checkEmptyData(packageInfo.basePackageInfo.unitPricePerLesson))) }}</div>
                          <div>VNĐ</div>
                        </div>
                      </div>
                    </div>
                    <div v-if="packageInfo.basePackageInfo && packageInfo.basePackageInfo.noteProductTransfer" class="d-flex" style="column-gap: 5px;">
                      <v-icon size="22" color="#FF4E4E">mdi-bookmark-outline</v-icon>
                      <div style="font-style: italic">{{ packageInfo.basePackageInfo.noteProductTransfer }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- SỐ TIỀN CÒN LẠI -->
              <div class="timeline-item">
                <div class="timeline-dot-2">
                  <span class=" font-weight-medium" style="color: #6F44FF;font-size: 15px">SỐ TIỀN CÒN LẠI</span>
                </div>
                <div class="timeline-content">
                  <div class="pl-2 pt-7 mb-2">
                    <div class="text-h5">
                      Tổng số tiền còn lại = <span class="font-weight-bold" style="color: #6F44FF !important;font-size: 16px !important;"> {{ packageInfo.remainingAmount ? formatPrice(checkEmptyData(packageInfo.remainingAmount)) : 0 }} VND</span>
                    </div>
                  </div>
                  <div class="d-flex" style="column-gap: 5px;">
                    <v-icon size="22" color="#FF4E4E">mdi-bookmark-outline</v-icon>
                    <div style="font-style: italic">Công thức: Tổng số tiền còn lại =  Thời hạn được phép chuyển phí x Giá một buổi</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="red--text ml-8 mt-4">( Lưu ý : Hệ thống sẽ auto chuyển phí hết buổi cũ khi thực hiện các tác vụ này. Các đơn hàng liên quan đến số buổi học cũ sẽ bị khóa )</div>

          </v-col>
          <!--           table right-->
          <v-col cols="6" style="padding-left: 24px !important;">
            <h2 class="text-center mb-4">GÓI MUỐN CHUYỂN</h2>
            <div class="mt-2 mb-1 d-flex align-center" style="justify-content: space-between;gap: 30px">
              <div class="mt-1 mb-1 d-flex align-center" style="justify-content: center;gap: 30px;width: 50%">
                <v-checkbox
                    color="success"
                    v-model="transferOptions.feeTransfer"
                    :disabled="transferOptions.assignmentTransfer || isDetail"
                    label="Chuyển phí"
                ></v-checkbox>
                <v-checkbox
                    color="success"
                    :disabled="true"
                    v-model="transferOptions.assignmentTransfer"
                    label="Chuyển nhượng"
                ></v-checkbox>
              </div>
              <div class="mt-1 mb-1 d-flex align-center" style="justify-content: center;gap: 30px;width: 50%">
                <v-checkbox
                    color="success"
                    v-model="transferOptions.language"
                    :disabled="transferOptions.additionalPayment  || isDetail"
                    label="Ngang tiền"
                ></v-checkbox>
                <v-checkbox
                    :disabled="transferOptions.language  || isDetail"
                    color="success"
                    v-model="transferOptions.additionalPayment"
                    label="Thanh toán thêm"
                ></v-checkbox>
              </div>
            </div>

            <!-- Form chọn sản phẩm -->
            <div class=" mt-3 mb-4" style="color: #6F44FF;font-weight: bold;font-size: 16px;">LỌC VÀ CHỌN SẢN PHẨM NHẬN PHÍ THEO ĐIỀU KIỆN</div>
            <template v-if="!transferOptions.additionalPayment">
              <div class="d-flex mb-3" style="gap: 10px;">
                <!--                  <div style="margin-top: 8px;font-weight:500;border-radius: 999px; width: 24px;height: 24px;border: 1px solid #6F44FF;display: flex;align-items: center;justify-content: center;color: #6F44FF">-->
                <!--                    {{ index + 1 }}-->
                <!--                  </div>-->
                <validation-observer tag="div" ref="refFormData" style="width: 100%">
                  <div style="width: 100%">
                    <div style="grid-template-columns: repeat(10, minmax(0, 1fr));display: grid; column-gap: 13px;">
                      <div style="grid-column: span 5 / span 5;">
                        <validation-provider v-slot="{ errors }" rules="required" name="Chương trình">
                          <v-autocomplete
                              :error-messages="errors"
                              dense
                              v-model="formModel.selectedProgram"
                              :items="programs"
                              outlined
                              :readonly="isDetail"
                              item-text="title"
                              item-value="id"
                              @change="changeProgram(formModel)"
                              placeholder="Chương trình"
                              no-data-text="Không có dữ liệu"
                              :menu-props="{ bottom: true, offsetY: true, maxHeight: '220' }"
                          />
                        </validation-provider>
                      </div>
                      <div style="grid-column: span 5 / span 5;">
                        <validation-provider v-slot="{ errors }" rules="required" name="Lộ trình">
                          <v-autocomplete
                              :error-messages="errors"
                              item-text="title"
                              item-value="id"
                              dense
                              :readonly="isDetail"
                              outlined
                              v-model="formModel.selectedLevel"
                              :items="formModel.listlevels"
                              placeholder="Lộ trình"
                              no-data-text="Không có dữ liệu"
                              @change="getSearchProduct(formModel)"
                              :menu-props="{ bottom: true, offsetY: true, maxHeight: '220' }"
                          />
                        </validation-provider>
                      </div>
                      <div style="grid-column: span 5 / span 5;">
                        <validation-provider v-slot="{ errors }" rules="required" name="Loại GV">
                          <v-autocomplete
                              :error-messages="errors"
                              dense
                              outlined
                              :readonly="isDetail"
                              v-model="formModel.selectedTeacherType"
                              :items="teacherTypes"
                              placeholder="Loại GV"
                              item-text="name"
                              item-value="id"
                              no-data-text="Không có dữ liệu"
                              @change="getSearchProduct(formModel)"
                              :menu-props="{ bottom: true, offsetY: true, maxHeight: '220' }"
                          />
                        </validation-provider>
                      </div>
                      <div style="grid-column: span 5 / span 5;">
                        <validation-provider v-slot="{ errors }" rules="required" name="Loại lớp">
                          <v-autocomplete
                              :error-messages="errors"
                              outlined
                              dense
                              :readonly="isDetail"
                              v-model="formModel.selectedClass"
                              :items="classes"
                              placeholder="Loại lớp"
                              item-text="name"
                              item-value="id"
                              no-data-text="Không có dữ liệu"
                              @change="getSearchProduct(formModel)"
                              :menu-props="{ bottom: true, offsetY: true, maxHeight: '220' }"
                          />
                        </validation-provider>
                      </div>
                    </div>
                    <div style="grid-template-columns: repeat(10, minmax(0, 1fr));display: grid; column-gap: 13px;">
                      <div style="grid-column: span 7 / span 7;">
                        <validation-provider v-slot="{ errors }" rules="required" name="Sản phẩm">
                          <v-autocomplete
                              :error-messages="errors"
                              dense
                              outlined
                              :readonly="isDetail"
                              item-readonly="readonly"
                              v-model="formModel.skuTutorId"
                              :items="formModel.listProduct"
                              placeholder="Chọn sản phẩm"
                              @change="handleSelectProduct(formModel)"
                              item-text="name"
                              item-value="id"
                              no-data-text="Không có dữ liệu"
                              :menu-props="{ bottom: true, offsetY: true, maxHeight: '220' }"
                          />
                        </validation-provider>
                      </div>
                      <div style="grid-column: span 3 / span 3;">
                        <div style="display: flex;align-items: center;justify-content:space-between;padding: 0 12px;width: 100%;border-collapse: collapse;border-color: #00000061; border-style: solid; border-width: 1px;; line-height: 38px;border-radius: 4px;">
                          <template v-if="formModel.unitPrice !== null ">
                            <div>{{ formatPrice(formModel.unitPrice) }}</div>
                            <div style="font-style:italic">VNĐ</div>
                          </template>
                          <template v-else>
                            <div style="font-style: italic;color: #B2B2B2">Đơn giá</div>
                          </template>
                        </div>
                      </div>
                    </div>
                    <div style="padding: 0 12px;width: 100%;border-collapse: collapse;border-color: #00000061; border-style: solid; border-width: 1px;; line-height: 38px;border-radius: 4px;">

                      <div v-if="formModel.quantity === null" style="font-style: italic;color: #B2B2B2">Số buổi tối đa của gói nhận phí : </div>
                      <div v-else>
                        Số buổi tối đa của gói nhận phí : <span style="padding-left: 5px;color:#009D3C" class="font-weight-medium">
                        {{ formModel.quantity !== null ? formModel.quantity : '--' }} buổi
                      </span>
                      </div>
                    </div>
                  </div>
                  <!--                  <div v-if="index === formModel.length - 1" @click="addProduct()" style="background: #7F7F7F;border-radius: 999px; width: 22px; height: 22px;display: flex;align-items: center;justify-content: center;margin-top: 40px;cursor: pointer">-->
                  <!--                  </div>-->
                </validation-observer>
              </div>
              <div class="mt-6 font-weight-medium">
                Giá trị 1 buổi của gói nhận phí : <span style="padding-left: 5px;color:#009D3C" class="font-weight-medium">
                  {{ formModel.priceLesson !== null ? formatPrice(Round2(formModel.priceLesson)) : '--' }} VND
                </span>
              </div>
            </template>
            <template v-if="transferOptions.additionalPayment">
              <template v-if="formModelAdditional && formModelAdditional.length">
                <validation-observer ref="validator">

                  <div v-for="(product, index) in formModelAdditional"  :key="index" class="d-flex mb-1" style="gap: 10px;">
                    <div style="margin-top: 8px;font-weight:500;border-radius: 999px; width: 24px;height: 23.5px;border: 1px solid #6F44FF;display: flex;align-items: center;justify-content: center;color: #6F44FF">
                      {{ index + 1 }}
                    </div>
                    <div style="width: calc(100% - 62px)">
                      <div style="grid-template-columns: repeat(15, minmax(0, 1fr));display: grid; gap: 13px;">
                        <div style="grid-column: span 5 / span 4;">
                          <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Chương trình" :vid="`selectedProgram+${index}`">
                            <v-autocomplete
                                dense
                                :error-messages="errors"
                                v-model="product.selectedProgram"
                                :items="programs"
                                outlined
                                item-text="title"
                                :readonly="isDetail"
                                item-value="id"
                                @change="changeProgram(product, ADDITIONAL)"
                                placeholder="Chương trình"
                                no-data-text="Không có dữ liệu"
                                :menu-props="{ bottom: true, offsetY: true, maxHeight: '220' }"
                            />
                          </validation-provider>
                        </div>
                        <div style="grid-column: span 4 / span 4;">
                          <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Lộ trình" :vid="`selectedLevel+${index}`">
                            <v-autocomplete
                                item-text="title"
                                item-value="id"
                                dense
                                :error-messages="errors"
                                outlined
                                v-model="product.selectedLevel"
                                :items="product.listlevels"
                                placeholder="Lộ trình"
                                :readonly="isDetail"
                                no-data-text="Không có dữ liệu"
                                @change="getSearchProduct(product, ADDITIONAL)"
                                :menu-props="{ bottom: true, offsetY: true, maxHeight: '220' }"
                            />
                          </validation-provider>
                        </div>
                        <div style="grid-column: span 3 / span 3;">
                          <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Loại GV" :vid="`selectedTeacherType+${index}`">
                            <v-autocomplete
                                dense
                                outlined
                                :error-messages="errors"
                                v-model="product.selectedTeacherType"
                                :items="teacherTypes"
                                placeholder="Loại GV"
                                item-text="name"
                                :readonly="isDetail"
                                item-value="id"
                                no-data-text="Không có dữ liệu"
                                @change="getSearchProduct(product, ADDITIONAL)"
                                :menu-props="{ bottom: true, offsetY: true, maxHeight: '220' }"
                            />
                          </validation-provider>
                        </div>
                        <div style="grid-column: span 3 / span 3;">
                          <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Loại lớp" :vid="`selectedClass+${index}`">
                            <v-autocomplete
                                outlined
                                dense
                                :error-messages="errors"
                                v-model="product.selectedClass"
                                :items="classes"
                                placeholder="Loại lớp"
                                item-text="name"
                                :readonly="isDetail"
                                item-value="id"
                                no-data-text="Không có dữ liệu"
                                @change="getSearchProduct(product, ADDITIONAL)"
                                :menu-props="{ bottom: true, offsetY: true, maxHeight: '220' }"
                            />
                          </validation-provider>
                        </div>
                      </div>
                      <div style="grid-template-columns: repeat(15, minmax(0, 1fr));display: grid; gap: 13px;">
                        <div style="grid-column: span 9 / span 9;">
                          <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Sản phẩm" :vid="`skuTutorId+${index}`">
                            <v-autocomplete
                                :error-messages="errors"
                                dense
                                outlined
                                v-model="product.skuTutorId"
                                :items="product.listProduct"
                                placeholder="Chọn sản phẩm"
                                @change="handleSelectProduct(product,ADDITIONAL)"
                                item-text="name"
                                item-value="id"
                                :readonly="isDetail"
                                no-data-text="Không có dữ liệu"
                                :menu-props="{ bottom: true, offsetY: true, maxHeight: '220' }"
                            />
                          </validation-provider>
                        </div>
                        <div  style="grid-column: span 3 / span 3;color: #495057 !important;" >
                          <div style='display: flex;align-items: center;font-size:14px;justify-content:space-between;padding: 0 8px;width: 100%;border-collapse: collapse;border-color: #00000061; border-style: solid; border-width: 1px;; line-height: 38px;border-radius: 4px;'>
                            <template v-if="product.unitPrice !== null ">
                              <div>{{ formatPrice(product.unitPrice) }}</div>
                              <div style="font-size: 13px;">VNĐ</div>
                            </template>
                            <template v-else>
                              <div style="font-style: italic;color: #B2B2B2">Đơn giá</div>
                            </template>
                          </div>
                        </div>
                        <div style="grid-column: span 3 / span 3;">
                          <validation-provider v-slot="{ errors }" :rules="{ required: true}" name="Số lượng" :vid="`quantity+${index}`">
                            <v-text-field
                                type="number"
                                :error-messages="errors"
                                dense
                                outlined
                                :readonly="isDetail"
                                :min="1"
                                :max="10000"
                                class="text-field-number"
                                v-model="product.quantity"
                                @input="product.quantity= product.quantity.replace(/[^0-9\.]/g,'');"
                                placeholder="SL"
                            />
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                    <div v-if="formModelAdditional.length > 1 && !isDetail " style="width: 22px; height: 22px;display: flex;align-items: center;justify-content: center;margin-top: 40px;cursor: pointer">
                      <v-icon @click.prevent="deleteProduct(product)" size="22" > mdi-delete</v-icon>
                    </div>
                  </div>
                </validation-observer>
              </template>
              <div v-if="!isDetail" class="d-flex justify-end" style="margin-right: 24px">
                <v-btn
                    @click="addProduct()"
                    style="background:#7B82FF !important;color: #FFF;height: 30px !important; text-transform: none !important; "
                    size="small"
                    color="#FF4C00;"
                >
                  Thêm sản phẩm +
                </v-btn>
              </div>
              <div class="ml-8 font-weight-medium">
                TỔNG GIÁ TRỊ MỚI : <span style="padding-left: 5px;color:#129700" class="font-weight-medium">{{ totalPrice !== 0 ? formatPrice(totalPrice) : '--' }} VND</span>
              </div>
            </template>

          </v-col>
        </v-row>

        <!-- Footer warning -->
        <!-- Action buttons -->
        <div v-if="!isDetail" class=" d-flex justify-lg-end">
          <v-btn
              class="mr-4"
              color="grey darken-1"
              dark
              style="color: #FFF; border-radius: 999px !important; "
              @click="cancel"
          >
            HỦY BỎ
          </v-btn>
          <v-btn
              style="background:#FF4C00 !important;color: #FFF; border-radius: 999px !important; "
              color="#FF4C00;"
              @click="handlePreviewTransfer()"
          >
            CHUYỂN PHÍ
          </v-btn>
        </div>
      </div>
      <template v-if="!isDetail">
        <v-dialog v-if="isPopupTransferPreview" v-model="isPopupTransferPreview" width='70vw' persistent>
          <v-card class="ticket-card pa-6">
            <div class="text-center mb-6" style="font-weight: 600; font-size: 18px">VUI LÒNG XÁC NHẬN THÔNG TIN CHUYỂN PHÍ</div>
            <transfer-ticket
                :transfer-fee-detail="transferFeeDetail"
            />
            <div class="mt-4 d-flex justify-center">
              <v-btn
                  class="mr-4"
                  color="grey darken-1"
                  dark
                  style="color: #FFF; border-radius: 999px !important; "
                  @click="isPopupTransferPreview = false"
              >
                HỦY BỎ
              </v-btn>
              <v-btn
                  style="background:#FF4C00 !important;color: #FFF; border-radius: 999px !important; "
                  color="#FF4C00;"
                  @click="transferProduct()"
              >
                XÁC NHẬN CHUYỂN PHÍ
              </v-btn>
            </div>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </v-card>
</template>
<script>
import TransferTicket from "../transfer-fee/TransferTicket.vue";
import TransferRepository from "../../repository/TransferRepository";
import _ from "lodash";
import { v1 as uuidv1 } from 'uuid';

const dataConst = {
  selectedProgram: null,
  selectedLevel: null,
  selectedTeacherType: null,
  selectedClass: null,
  skuTutorId: null,
  listProduct: [],
  listlevels: [],
  unitPrice: null,
  quantity: null,
  priceLesson: null,
  id: uuidv1()

};
const packageInfoConst = {
  oldPackageInfo: {
    numberLessonFeeReceived: {},
    numberLesson: {},
    packageName: null,
    numberLessonTransfer: null,
    programGroup: null,
  },
  basePackageInfo: {},
  remainingAmount: null,
  studentProduct: {},
};
export default {
  name: 'TransferFeeDetail',
  props: {
    isPopupTransferFee: {
      type: Boolean,
      default: false,
    },
    student: {
      type: Object,
      default: () => {
      },
    },
    urlERP: {
      type: String,
      default: process.env.VUE_APP_SORT_CLASS,
    },
    urlOMS: {
      type: String,
      default: process.env.VUE_APP_API_OMS,
    },
    urlCRM: {
      type: String,
      default: process.env.VUE_APP_API_ERP,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    idTransfer: {
      type: String,
      default: '',
    },
  },
  components: {TransferTicket},
  data: () => ({
    transferFeeDetail: {},
    isPopupTransferPreview: false,
    transferOptions: {
      feeTransfer: true,
      assignmentTransfer: false,
      language: true,
      additionalPayment: false,
    },
    formModel: {...dataConst},
    formModelAdditional: [{...dataConst}],
    packageInfo: {...packageInfoConst},
    programs: [],
    levels: [],
    teacherTypes: [],
    classes: [],
    products: [],
    ADDITIONAL: 'additionalPayment'

  }),
  async created() {
    await this.getListPrograms();
    await this.getListProductAttributes();
    if (this.isDetail && this.idTransfer) {
      await this.getDetailNowPackage(this.idTransfer);
    } else {
      await this.getTransferOrder();
    }
  },
  computed: {
    totalPrice() {
      return this.formModelAdditional.reduce((accumulator, product) => {
        return accumulator + parseInt(product.unitPrice * product.quantity);
      }, 0);
    }
  },
  methods: {
    addProduct() {
      this.formModelAdditional.push({...dataConst, id: uuidv1()});
    },
    deleteProduct(product) {
      this.formModelAdditional = this.formModelAdditional.filter((item) => item.id !== product.id);
    },
    formatPrice(value) {
      const valueABS = Math.abs(value);
      if (Number.isNaN(valueABS)) return value;
      if (valueABS > -1000 && valueABS < 1000) {
        return value;
      }
      const valueNumber = Intl.NumberFormat('en-US').format(valueABS.toFixed());
      if (Number(value) < 0) {
        return `-${valueNumber}`;
      }
      return valueNumber;
    },
    handleClosePopup() {
      this.$emit('close')
    },
    async getDetailNowPackage(id) {
      try {
        const loading = this.$loading.show()
        const response = await TransferRepository.getDetailTransferOrderApi(this.urlERP, id);
        loading.hide()
        if (response.success) {
          this.transferOptions.feeTransfer = response.data.typeTransfer.id === 1;
          this.transferOptions.assignmentTransfer = response.data.typeTransfer.id === 2;
          this.transferOptions.language = response.data.paymentMethod.id === 1;
          this.transferOptions.additionalPayment = response.data.paymentMethod.id === 2;
          this.packageInfo = response.data;
          if (this.transferOptions.language) {
            const product = response.data.newPackageInfo ? response.data.newPackageInfo : {};
            this.formModel.selectedProgram = product.curriculumId;
            const dataFind = this.programs.find((item) => item.id === this.formModel.selectedProgram);
            this.formModel.listlevels = dataFind ? dataFind.program_groups : [];
            this.formModel.selectedLevel = product.programGroupId ? product.programGroupId : null;
            this.formModel.selectedTeacherType = product.teacherTypeId;
            this.formModel.selectedClass = product.classTypeId;
            const params = {
              curriculum_id: this.formModel.selectedProgram,
              teacher_type_ids: this.formModel.selectedTeacherType,
              class_type_ids: this.formModel.selectedClass,
              learning_path_ids: this.formModel.selectedLevel,
              include_price_policy: 1,
              status: 'active',
              num_of_lesson: 1,
            };
            const resProduct = await TransferRepository.getListProductApi(this.urlOMS, params);
            this.formModel.listProduct = resProduct.data;
            this.formModel.skuTutorId = product.skuTutor.id;
            this.formModel.unitPrice = product.orgPrice;
            this.formModel.quantity = product.numberTargetLesson;
            this.formModel.priceLesson = product.singleLessonPrice;

          } else if (this.transferOptions.additionalPayment) {

            const product = response.data.newProducts ? response.data.newProducts : [];
            this.formModelAdditional = await Promise.all(product.map(async (item) => {
              const params = {
                curriculum_id: item.curriculumId,
                teacher_type_ids: item.teacherTypeId,
                class_type_ids: item.classTypeId,
                learning_path_ids: item.programGroupId,
                include_price_policy: 1,
                status: 'active',
              };
              const resProduct = await TransferRepository.getListProductApi(this.urlOMS, params);
              const dataFind = this.programs.find((item2) => item2.id === item.curriculumId);
              return {
                listProduct: resProduct.data,
                listlevels: dataFind ? dataFind.program_groups : [],
                selectedProgram: item.curriculumId,
                selectedLevel: item.programGroupId,
                selectedTeacherType: item.teacherTypeId,
                selectedClass: item.classTypeId,
                skuTutorId: item.skuTutorId,
                unitPrice: item.intoMoney,
                quantity: item.quantity,
              }
            }))
          }
        } else {
          this.packageInfo = {...packageInfoConst};
          this.transferOptions = {
            feeTransfer: true,
            assignmentTransfer: false,
            language: true,
            additionalPayment: false,
          };
          this.formModel = {...dataConst};
        }
      } catch (e) {
        console.log(e);
      }
    },
    Round2(num) {
      return Math.round(num * 100) / 100;
    },
    async getTransferOrder() {
      try {
        const params = {
          studentProductId: this.student.student_product_id,
        };
        const response = await TransferRepository.getTransferOrderApi(this.urlERP, params);
        if (response.success) {
          if (response.data) {
            this.packageInfo = response.data;
          } else {
            this.packageInfo = {...packageInfoConst};
          }
        } else {
          // this.$emit('closePopup');
          this.$swal({
            icon: 'error',
            type: 'error',
            title: response.errors.message,
            showConfirmButton: true,
            timer: 3000,
          });
          this.packageInfo = {...packageInfoConst};
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getListPrograms() {
      try {
        const response = await TransferRepository.getListProgramApi(this.urlCRM);
        if (response.success) {
          this.programs = response.data;
        } else {
          this.programs = [];
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getListProductAttributes() {
      try {
        const response = await TransferRepository.getListProductAttributesApi(this.urlOMS);
        if (response.success) {
          if (response.data) {
            this.teacherTypes = response.data.teacherTypes;
            this.classes = response.data.classTypes;
          } else {
            this.teacherTypes = [];
            this.classes = [];
          }
        } else {
          this.teacherTypes = [];
          this.classes = [];
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleSelectProduct(product, type) {
      if (product.skuTutorId) {
        const productItem = product.listProduct.find((item) => product.skuTutorId === item.id);
        if (this.packageInfo && (this.packageInfo.remainingAmount !== null || this.packageInfo.remainingAmount !== '')) {
          // const pricePolicie = productItem.pricePolicies ? productItem.pricePolicies[0] : [];
          // const numberLesson = productItem.numOfLesson + pricePolicie.additionalNumOfLesson;
          // const priceLesson = productItem.orgPrice / numberLesson;
          if (type !== this.ADDITIONAL) {
            product.unitPrice = productItem.orgPrice;
            const totalTransferLesson = Math.round(this.packageInfo.remainingAmount / productItem.priceLesson);
            product.quantity = totalTransferLesson && totalTransferLesson !== Infinity ? _.cloneDeep(totalTransferLesson) : '--';
            product.priceLesson = _.cloneDeep(productItem.priceLesson);
          } else {
            const pricePolicie = productItem.pricePolicies ? productItem.pricePolicies[0] : [];
            product.unitPrice = pricePolicie.priceType === 'unchanged' ? pricePolicie.minPrice : (pricePolicie.priceType === 'custom' ? pricePolicie.maxPrice : 0);
            product.quantity = 1
          }
        }
      } else {
        product.quantity = null;
        product.unitPrice = null;
        product.priceLesson = null;
      }
    },
    async getSearchProduct(item, type) {
      console.log(type, 'type')
      if (item.selectedProgram && item.selectedTeacherType && item.selectedClass && item.selectedLevel) {
        try {
          const params = {
            curriculum_id: item.selectedProgram,
            teacher_type_ids: item.selectedTeacherType,
            class_type_ids: item.selectedClass,
            learning_path_ids: item.selectedLevel,
            include_price_policy: 1,
            status: 'active',
          };
          if (this.transferOptions.language) {
            params['num_of_lesson'] = 1
          }
          const response = await TransferRepository.getListProductApi(this.urlOMS, params);
          if (response.success) {
            item.listProduct = response.data;
            if (response.data.length) {
              // eslint-disable-next-line no-shadow
              item.listProduct = item.listProduct.map((product) => {
                const pricePolicie = product.pricePolicies ? product.pricePolicies[0] : [];
                const numberLesson = Number(product.numOfLesson + (pricePolicie.additionalNumOfLesson !== null ? pricePolicie.additionalNumOfLesson : 0));
                return {
                  ...product,
                  numberLesson,
                  priceLesson: product.orgPrice / numberLesson,
                  readonly: this.packageInfo.remainingAmount !== null && product.orgPrice !== 0 ? Number(this.packageInfo.remainingAmount) < (product.orgPrice) : true,
                };
              });
            }
            item.skuTutorId = null;
            item.unitPrice = null;
            item.quantity = null;
            item.priceLesson = null;
          } else {
            item.listProduct = [];
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    changeProgram(product, type) {
      console.log(type, 'type')
      if (product) {
        const dataFind = this.programs.find((item) => item.id === product.selectedProgram);
        product.listlevels = dataFind ? dataFind.program_groups : [];
        this.getSearchProduct(product);
      } else {
        this.selectedLevel = null;
        this.levels = [];
      }
    },
    checkEmptyData(data) {
      return data != null || data !== '' ? data : '';
    },
    cancel() {
      this.$emit('close');
      this.$refs.refFormData.reset();
    },
    async handleAdditionalPayment() {
      try {
        if (Number(this.totalPrice) <= Number(this.packageInfo.remainingAmount)) {
          this.$swal({
            icon: 'error',
            type: 'error',
            text: '“Tổng giá trị mới” nhỏ hơn hoặc bằng “Tổng số tiền còn lại”. Không thể thanh toán thêm ',
            showConfirmButton: true,
            timer: 2500,
          });
          return
        }
        const data = {
          studentProductId: this.student.student_product_id,
          remainingAmount: this.packageInfo.remainingAmount,
          typeTransfer: this.transferOptions.feeTransfer ? 1 : (this.transferOptions.assignmentTransfer ? 2 : 0),
          paymentMethod: this.transferOptions.language ? 1 : (this.transferOptions.additionalPayment ? 2 : 0),
          totalNewProductAmount: this.totalPrice,
        }
        data.newProducts = this.formModelAdditional.map(item => {
          return {
            curriculumId: item.selectedProgram,
            programGroupId: item.selectedLevel,
            teacherTypeId: item.selectedTeacherType,
            classTypeId: item.selectedClass,
            intoMoney: item.unitPrice,
            skuTutorId: item.skuTutorId,
            quantity: item.quantity,
          }
        })
        const loader = this.$loading.show();
        const response = await TransferRepository.callExtraFeeTransferApi(this.urlERP, data);
        loader.hide();
        if (response.success) {
          const currentPath = this.$route.fullPath;
          const urlCRM = process.env.VUE_APP_CRM
          window.open(`${urlCRM}/contact/contact-list/${this.student.contact_id}/update-contact-info?record_type=transfer_product&record_id=${response.data._id}&url_back=${currentPath}`, '_blank');
          this.$emit('close');
        } else {
          this.$swal({
            icon: 'error',
            type: 'error',
            title: response.errors.message,
            showConfirmButton: true,
            timer: 2500,
          });
        }
      } catch (e) {
        console.log(e)
      }
    },
    async handlePreviewTransfer() {
      if (this.transferOptions.additionalPayment) {
        const valid = await this.$refs.validator.validate();
        if (valid) {
          await this.handleAdditionalPayment()
        }
      } else {
        const valid = await this.$refs.refFormData.validate();
        if (valid) {
          try {
            const params = {
              studentProductId: this.student.student_product_id,
              skuTutorId: this.formModel.skuTutorId,
              // eslint-disable-next-line no-nested-ternary
              typeTransfer: this.transferOptions.feeTransfer ? 1 : (this.transferOptions.assignmentTransfer ? 2 : 0),
              // eslint-disable-next-line no-nested-ternary
              paymentMethod: this.transferOptions.language ? 1 : (this.transferOptions.additionalPayment ? 2 : 0),
              curriculumId: this.formModel.selectedProgram,
              programGroupId: this.formModel.selectedLevel,
              teacherTypeId: this.formModel.selectedTeacherType,
              classTypeId: this.formModel.selectedClass,
              intoMoney: this.formModel.unitPrice,
            };
            if (params.paymentMethod === 0 || params.typeTransfer === 0) {
              this.$swal({
                icon: 'error',
                type: 'error',
                title: 'Vui lòng chọn loại chuyển phí.',
                showConfirmButton: true,
                timer: 2500,
              });
            } else {
              const loader = this.$loading.show();
              const response = await TransferRepository.getPreviewTransferApi(this.urlERP, params);
              loader.hide();
              if (response.success) {
                this.isPopupTransferPreview = true;
                this.transferFeeDetail = response.data;
              } else {
                this.$swal({
                  icon: 'error',
                  type: 'error',
                  title: response.errors.message,
                  showConfirmButton: true,
                  timer: 2500,
                });
              }
            }
          } catch (e) {
            console.log(e);
          }
        }
      }
    },
    async transferProduct() {
      const valid = await this.$refs.refFormData.validate();
      if (valid) {
        try {
          const data = {
            studentProductId: this.student.student_product_id,
            skuTutorId: this.formModel.skuTutorId,
            // eslint-disable-next-line no-nested-ternary
            typeTransfer: this.transferOptions.feeTransfer ? 1 : (this.transferOptions.assignmentTransfer ? 2 : 0),
            // eslint-disable-next-line no-nested-ternary
            paymentMethod: this.transferOptions.language ? 1 : (this.transferOptions.additionalPayment ? 2 : 0),
            curriculumId: this.formModel.selectedProgram,
            programGroupId: this.formModel.selectedLevel,
            teacherTypeId: this.formModel.selectedTeacherType,
            classTypeId: this.formModel.selectedClass,
            intoMoney: this.formModel.unitPrice,
          };
          if (data.paymentMethod === 0 || data.typeTransfer === 0) {
            this.$swal({
              icon: 'error',
              type: 'error',
              title: 'Vui lòng chọn loại chuyển phí.',
              showConfirmButton: false,
              timer: 2500,
            });
          } else {
            const loader = this.$loading.show();
            const response = await TransferRepository.createTransferOrderApi(this.urlERP, data);
            loader.hide();
            if (response.success) {
              this.$emit('close');
              this.isPopupTransferPreview = false;
              this.$swal({
                icon: 'success',
                type: 'success',
                title: 'Chuyển phí thành công.',
                showConfirmButton: true,
                timer: 2500,
              });
            } else {
              this.$swal({
                icon: 'error',
                type: 'error',
                title: response.errors.message,
                showConfirmButton: true,
                timer: 2500,
              });
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
};
</script>
<style scoped>
.v-data-table {
  background-color: transparent !important;
}

.v-autocomplete ::placeholder {
  font-style: italic !important;
}

.border-right {
  border-right: 1px solid #e0e0e0;
  padding-right: 24px;
}

.timeline {
  position: relative;
  padding-left: 8px;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 11px;
  top: 0;
  height: 100%;
  width: 2px;
  background-color: #6F44FF;
  opacity: 0.3;
}

.timeline-item {
  position: relative;
  margin-bottom: 24px;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-dot {
  position: absolute;
  left: -7.5px;
  top: 0;
  z-index: 2;
  background: white;
}

.timeline-dot-2 {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  background: white;
}

.timeline-content {
  padding-left: 24px;
}

.custom-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;

  table {
    background: #fff !important;
  }
}

.custom-table ::v-deep td {
  font-size: 14px !important;
}

.custom-table ::v-deep th {
  color: #5D62D1 !important;
  border-right: 1px solid #FFF;
}

.custom-table ::v-deep th:last-child {
  color: #5D62D1 !important;
  border-right: 0 solid #FFF !important;
}

.custom-table-2 ::v-deep th, .custom-table ::v-deep th {
  font-weight: 500 !important;
  font-size: 13px !important;
  height: 36px !important;
}

.timeline-header {
  display: flex;
  align-items: center;
}

.transfer-fee {
  input {
    font-size: 14px !important;
  }

  .v-text-field__details {
    padding-left: 0 !important;
  }
}

.content-tooltip-transfer {
  box-shadow: 4px 4px 4px 0 rgba(102, 102, 102, 0.25);
  background: #fff !important;
}

</style>
<style lang="scss">
.v-input {
  &.text-field-number {
    .v-input__control {
      .v-input__slot {
        .v-input__append-inner {
          display: none !important;
        }
      }
    }
  }
}

.text-field-number input[type="number"]::-webkit-outer-spin-button,
.text-field-number input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.text-field-number input[type="number"] {
  -moz-appearance: textfield;
}
</style>
